import styled from '@emotion/styled';
import { ShimmerPlaceholder } from '../../../../../../ui';

export const TextPlaceholder = styled(ShimmerPlaceholder)<{ width?: string }>`
	width: ${({ width }) => width || '80%'};
	height: 1.2em;
	margin-bottom: 12px;
`;
